import { Component, Inject, OnInit, SecurityContext } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { ModalTitleComponent } from "../../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: 'app-show-payment-image-modal',
    templateUrl: './show-payment-image-modal.component.html',
    imports: [BaseIndexModule, ModalTitleComponent]
})
export class ShowPaymentImageModalComponent implements OnInit {
  //#region Properties
  image: string;
  pdfUrl: any;

  extensionSignatures = {
    JVBERi0: 'application/pdf',
    R0lGODdh: 'image/gif',
    R0lGODlh: 'image/gif',
    iVBORw0KGgo: 'image/png',
    '/9j/': 'image/jpg',
  };
  //#endregion

  constructor(
    private dialogRef: MatDialogRef<ShowPaymentImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    for (var extensionSignature in this.extensionSignatures) {
      if (this.data.indexOf(extensionSignature) === 0) {
        //get pdf url
        if (this.extensionSignatures[extensionSignature] == 'application/pdf') {
          let blob = this.base64ToBlob(this.data);
          this.pdfUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
            URL.createObjectURL(blob)
          );
          this.image = null;
        } else {
          //get image url
          this.image = this._sanitizer.sanitize(
            SecurityContext.RESOURCE_URL,
            this._sanitizer.bypassSecurityTrustResourceUrl(
              'data:image/png;base64,' + this.data
            )
          );
          this.pdfUrl = null;
        }
      }
    }
  }

  base64ToBlob(base64String: string): Blob {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: 'application/pdf' });
  }

  onClose() {
    this.dialogRef.close();
  }
}
